import {
    createContext,
    useContext
} from "react";
import type {
    FieldActionContextType
} from "./type";

export const FieldActionContext = createContext<FieldActionContextType>({
    isPressed: false
});

export const useFieldActionContext = (): FieldActionContextType => {
    return useContext(FieldActionContext);
};
